export default __webpack_public_path__ + "static/media/speedometer (1).574d95c7.svg";